import script from "./bOrdersCommons.vue?vue&type=script&lang=js"
export * from "./bOrdersCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__